import { TYPO } from "styles/Typo";
import { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ActiveRadioIcon, InactiveRadioIcon } from "../util/Icon";
import { AmountInput, AmountInputHelper, SurveyTitle } from "../util/component";
import { s3UrlSpace, useRecommandData } from "../util/recommand";
import RecommandBox from "../util/survey/RecommandBox";

interface Step2Props {
  value: number | null;
  handleValue: (option: number) => void;
  options?: { retire_lifestyle_amount: number | null };
}

export default function Step2({ value, handleValue }: Step2Props) {
  // const options = externalOptions || [
  //   {
  //     id: "basic_mode",
  //     label: "생존모드",
  //     desc: "월 100만원 사용",
  //   },
  //   {
  //     id: "enough_mode",
  //     label: "소확행 라이프",
  //     desc: "월 20만원 사용",
  //   },
  //   {
  //     id: "traveler_mode",
  //     label: "여행자 모드",
  //     desc: "월 300만원 사용",
  //   },
  //   {
  //     id: "luxury_mode",
  //     label: "제 2의 황금기",
  //     desc: "월 500만원 사용",
  //   },
  // ];
  const { data, isLoading, isError } = useRecommandData(
    "retire_lifestyle_amount",
    value
  );

  return (
    <div className="bg-background relative w-full ">
      <div className="content-stretch flex flex-col items-start justify-start w-full">
        <SurveyTitle text={"은퇴 후 매달 얼마나 쓸 건가요?"} />
        <div className="px-6 py-4 w-full space-y-6">
          <div className=" space-y-[10px]">
            <AmountInput
              value={value}
              setValue={handleValue}
              dataGtmId="saa-survey-target-amount-input"
            />
            <AmountInputHelper
              setValue={handleValue}
              units={[100, 300, 500]}
              value={value || 0}
              dataGtmId="saa-survey-target-amount-input-helper"
            />
          </div>
          {data?.length > 0 && (
            <RecommandBox value={value}>
              {data?.map((item: any, index: number) => (
                <div
                  className="flex justify-between gap-1 items-center"
                  key={index}
                >
                  <div>
                    <p className={`${TYPO.TYPO7_RG} custom-word-break`}>
                      <span className="text-blue50">{item?.["구간"]}</span>{" "}
                    </p>
                    <p className={`${TYPO.TYPO7_RG} custom-word-break`}>
                      <span className="text-gray70">
                        {item?.["생활양상"]} 가능
                      </span>
                    </p>
                  </div>
                  {/* <img
                    src={s3UrlSpace(item?.s3_url || "")}
                    alt="recommand"
                    width={95}
                    height={44}
                    className="object-cover aspect-[16/9] w-[90px] "
                  /> */}
                </div>
              ))}
            </RecommandBox>
          )}
        </div>
      </div>
    </div>
  );
}
